import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../../AppStateProvider';
import type { OpportunityList } from '../../../domain/list';
import { OpportunityListTypeEnum } from '../../../domain/list';
import { opportunityListsApi } from '../api';

import opportunityListQueryKey from './opportunityListQueryKey';

export const useOpportunityListQuery = (): UseQueryResult<OpportunityList[]> => {
  const { isOpen } = useAppState();

  const query = useQuery({
    queryKey: opportunityListQueryKey.list(),
    queryFn: async ({ signal }) => {
      const lists = await opportunityListsApi.getOpportunityList(signal);
      return lists.filter((list) => list.type !== OpportunityListTypeEnum.RecentlyViewed);
    },
    enabled: isOpen,
    retry: false,
    refetchInterval: false,
  });

  return query;
};
